import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash.isempty';
import NumberFormat from 'react-number-format';
import monthList from '../PublicHoliday/monthList.json'
import { DatePicker } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import locale from 'antd/es/date-picker/locale/de_DE';
import moment from 'moment'
import numeral from 'numeral';
import 'numeral/locales/de'
import {
  Grid, Button, TextField,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from '@material-ui/core';
import { GetProjectPlansForYear, CreateProjectPlansForYear } from './ProjectsAction';

numeral.locale('de');

const dateFormat = 'YYYY';
const formatter = new Intl.NumberFormat('de-DE', {
  currency: 'EUR',
})
class Planning extends Component {

  state = {
    yearField: new Date().getFullYear(),
    sumDaysold: [],
    sumDaysassigned: [],
    sumIst: [],
    cuurentMonth: new Date().getMonth(),
    currentDay: new Date().getDate(),
    propsProjectData: this.props.project_data,
    tolerancePlaning: this.props.project_data.toleranceplaning,
    projectPlans: this.props.project_plans_for_year,
    compareList: '',
    comparedValText: '',
    color: '',
    monthsKey: ["summary", "january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"]
  }


  componentDidMount = () => {
    const { propsProjectData, yearField } = this.state
    const { GetProjectPlansForYear } = this.props
    GetProjectPlansForYear(propsProjectData.id, yearField)

    this.tolerancePlaningCheck()
  }

  tolerancePlaningCheck = () => {
    const { tolerancePlaning } = this.state
    var my_date = new Date();
    let currentDay = my_date.getDate()
    var month = new Date().getMonth();

    if (Math.sign(tolerancePlaning) === -1) {
      let last_date = new Date(my_date.getFullYear(), my_date.getMonth() + 1, 0);
      let lastday = last_date.getDate() + tolerancePlaning
      if (currentDay <= lastday) {
        this.setState({ cuurentMonth: month })
      } else {
        this.setState({ cuurentMonth: month + 1 })
      }
    } else {
      if (currentDay <= tolerancePlaning) {
        this.setState({ cuurentMonth: month - 1 })
      } else {
        this.setState({ cuurentMonth: month })
      }
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { project_plans_for_year } = this.props
    if (nextProps.project_plans_for_year !== project_plans_for_year) {
      this.createDataForMap(nextProps.project_plans_for_year, '', '', true)
      this.props.isBlockingCheckfalse()
    }
  }

  createProjectPlan = () => {
    const { CreateProjectPlansForYear } = this.props
    const { propsProjectData, projectPlans, monthsKey, yearField } = this.state
    CreateProjectPlansForYear(propsProjectData.id, projectPlans, monthsKey, yearField)

  }

  createDataForMap = (Plans, data, key, blockTab) => {
    let { monthsKey, yearField } = this.state
    let sumdaysold = []
    let sumdayassign = []
    let sumist = []
    let rowSumold = []
    let rowDayassign = []
    let rowIst = []
    let compare = {}
    let compareKey

    if (Plans) {
      Plans.map((item, rowIndex) => {
        compareKey = item.consultant_function_id + '_' + yearField
        monthsKey.forEach((key, index) => {
          if (item.project_plans[key]) {
            if (key !== "summary") {
              if (rowSumold[rowIndex]) {
                if (compare[compareKey]) {
                  compare[compareKey] += Number(item.project_plans[key][0].dayssold)
                } else {
                  compare[compareKey] = Number(item.project_plans[key][0].dayssold)
                }
                rowSumold[rowIndex] += Number(item.project_plans[key][0].dayssold)
                item.project_plans['summary'][0].dayssold = rowSumold[rowIndex]
              } else {
                if (compare[compareKey]) {
                  compare[compareKey] += Number(item.project_plans[key][0].dayssold)
                } else {
                  compare[compareKey] = Number(item.project_plans[key][0].dayssold)
                }
                rowSumold[rowIndex] = Number(item.project_plans[key][0].dayssold)
                item.project_plans['summary'][0].dayssold = rowSumold[rowIndex]
              } if (rowDayassign[rowIndex]) {
                rowDayassign[rowIndex] += Number(item.project_plans[key][0].daysassigned)
                item.project_plans['summary'][0].daysassigned = rowDayassign[rowIndex]
              } else {
                rowDayassign[rowIndex] = Number(item.project_plans[key][0].daysassigned)
                item.project_plans['summary'][0].daysassigned = rowDayassign[rowIndex]
              } if (rowIst[rowIndex]) {
                rowIst[rowIndex] += Number(item.project_plans[key][0].ist)
                item.project_plans['summary'][0].ist = rowIst[rowIndex]
              } else {
                rowIst[rowIndex] = Number(item.project_plans[key][0].ist)
                item.project_plans['summary'][0].ist = rowIst[rowIndex]
              }
            }
          }
        })

      })
      Plans.map((item) => {
        monthsKey.forEach((key, index) => {
          if (item.project_plans[key]) {
            if (sumdaysold[index]) {
              sumdaysold[index] += Number(item.project_plans[key][0].dayssold)
            } else {
              sumdaysold[index] = Number(item.project_plans[key][0].dayssold)
            }
            if (sumdayassign[index]) {
              sumdayassign[index] += Number(item.project_plans[key][0].daysassigned)
            } else {
              sumdayassign[index] = Number(item.project_plans[key][0].daysassigned)
            }
            if (sumist[index]) {
              sumist[index] += Number(item.project_plans[key][0].ist)
            } else {
              sumist[index] = Number(item.project_plans[key][0].ist)
            }
          } else {
            if (!sumdaysold[index]) {
              sumdaysold[index] = ''

            }
            if (!sumdayassign[index]) {
              sumdayassign[index] = ''
            }
            if (!sumist[index]) {
              sumist[index] = ''
            }
          }
        })
      })

      this.setState({
        projectPlans: Plans,
        sumDaysassigned: sumdayassign,
        sumDaysold: sumdaysold,
        sumIst: sumist,
        compareList: compare
      }, () => {
        if (key === "dayssold")
          this.compareValFunction(data)
        else
          this.setState({ comparedValText: '' })
        if (!blockTab)
          this.props.isBlockingCheck()
      })
    }
  }

  monthCells = () => {
    return (
      monthList.map((item, index) => <TableCell key={index} align="center">{item.name}</TableCell>)
    )
  }

  compareValFunction = (data) => {
    const { projectPlans, yearField, compareList } = this.state
    let comparedText = ''
    let colour = ""

    projectPlans.forEach((item, index) => {
      if (data)
        if (item.id === data.id) {
          let compareKey = item.consultant_function_id + '_' + yearField
          if (compareList[compareKey] >= item.capacity_tab_value) {
            comparedText = `geplante Tage für die Funktion ${item.consultant_function} in ${yearField}: ${formatter.format(compareList[compareKey])}  Tage / Kapazitätsplanung: ${formatter.format(item.capacity_tab_value)}   Tage`
            colour = "red"
          } else {
            comparedText = `geplante Tage für die Funktion ${item.consultant_function} in ${yearField}: ${formatter.format(compareList[compareKey])}  Tage / Kapazitätsplanung: ${formatter.format(item.capacity_tab_value)}   Tage`
            colour = "green"
          }
        }
    })

    this.setState({ comparedValText: comparedText, color: colour })

  }

  yearFieldHandleChange = (e) => {
    const { propsProjectData } = this.state

    if (e !== null) {
      let date = e._d.getFullYear()
      this.setState({ yearField: date })
      this.props.GetProjectPlansForYear(propsProjectData.id, date)
    } else {
      this.setState({ yearField: '' })
    }
  }

  handleFieldsChange = (e, data, month, key) => {
    const { projectPlans } = this.state

    projectPlans.map((item, index) => {
      if (item.project_plans[month]) {
        if (item.id === data.id) {
          if (key === "dayssold") {
            item.project_plans[month][0].dayssold = e.target.value === "" ? "" : numeral(e.target.value).value()
          }
          if (key === "daysassigned") {
            item.project_plans[month][0].daysassigned = e.target.value === "" ? "" : numeral(e.target.value).value()
          }
        }
      }
    })
    this.createDataForMap(projectPlans, data, key)
  }

  handleNewMonthAdd = (e, data, month, key) => {
    const { projectPlans } = this.state

    projectPlans.map((item, index) => {
      if (item.id === data.id) {
        if (key === "dayssold") {
          item.project_plans = Object.assign({ [month]: [{ "month": month, "daysassigned": '', "dayssold": numeral(e.target.value).value(), "ist": '' }] }, item.project_plans)
        }
        if (key === "daysassigned") {
          item.project_plans = Object.assign({ [month]: [{ "month": month, "dayssold": '', "daysassigned": numeral(e.target.value).value(), "ist": '' }] }, item.project_plans)
        }
      }
    })
    this.createDataForMap(projectPlans, data, key)
  }

  render() {
    const { comparedValText, color, yearField, projectPlans, cuurentMonth, monthsKey, sumDaysold, sumDaysassigned, sumIst } = this.state
    const { rest_gemsat, rest_year, forOther, forOwn } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    return (
      <div
        className={`plainingTab ${(Number(access_rights.projects_planning_for_other) !== 2 && forOther) || (Number(access_rights.projects_planning_for_own) !== 2 && !forOwn && !forOther) || (Number(access_rights.projects_planning_for_own) !== 2 && forOwn) ? "disableALlFields" : ""}`}
      >
        {!((Number(access_rights.projects_planning_for_other) !== 2 && forOther) || (Number(access_rights.projects_planning_for_own) !== 2 && forOwn)) &&
          <Button variant="outlined" style={{ float: 'right' }} color="primary" className="m-10" onClick={this.createProjectPlan} >Speichern</Button>
        }
        <Grid container spacing={1}>
          <Grid item xs={2} className="inner-p-label">
            Jahr
          </Grid>
          <Grid item xs={2}>
            <DatePicker
              value={yearField === "" ? '' : moment(yearField, dateFormat)}
              format={dateFormat}
              allowClear={false}
              bordered={false}
              onChange={(e) => {
                this.yearFieldHandleChange(e)
              }}
              picker="year" />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={2} className="inner-p-label">
            Rest verk. {yearField}
          </Grid>
          <Grid item xs={2}>
            <NumberFormat
              customInput={TextField}
              className="innerInput rightToLeft"
              inputProps={{
                maxLength: 10
              }}
              disabled
              variant="outlined"
              value={Number(rest_year)}
              thousandSeparator='.'
              decimalSeparator=","
              fixedDecimalScale={true}
              decimalScale="2"
            />
          </Grid>
          <Grid item xs={2} className="inner-p-label text-center">
            Rest verk. gesamt
          </Grid>
          <Grid item xs={2}>
            <NumberFormat
              customInput={TextField}
              className="innerInput rightToLeft"
              inputProps={{
                maxLength: 10
              }}
              disabled
              variant="outlined"
              value={Number(rest_gemsat)}
              thousandSeparator='.'
              decimalSeparator=","
              fixedDecimalScale={true}
              decimalScale="2"
            />
          </Grid>
        </Grid>

        <div className="plainingTable tabsTableStyle">
          <Grid container spacing={0}>
            <Grid item xs={2}>
              <TableContainer>
                <Table className="br-0 left-allign-lip">
                  <TableHead className="pl-heading">
                    <TableRow>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow className="pl-heading">
                      <TableCell align="left">
                        <div className="innerMonth">
                          <div>Funktion</div>
                        </div>
                      </TableCell>
                      <TableCell align="left">
                        <div className="innerMonth">
                          <div>Berater</div>
                        </div>
                      </TableCell>
                    </TableRow>

                    {projectPlans &&
                      projectPlans.map((item, index) => (
                        <TableRow key={index} className="pl-heading">
                          <TableCell align="left">
                            <div className="innerMonth">
                              <div>{item.consultant_function}</div>
                            </div>
                          </TableCell>
                          <TableCell align="left">
                            <div className="innerMonth">
                              <div>{item.login_name}</div>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    }
                    <TableRow className="pl-heading">
                      <TableCell align="left">
                        <div className="innerMonth">
                          <div>Summe</div>
                        </div>
                      </TableCell>
                      <TableCell align="center">
                        <div className="innerMonth">
                          <div></div>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={10}>
              <div className="overflow-x-auto">
                <TableContainer>
                  <Table>
                    <TableHead className="pl-heading">
                      <TableRow>
                        <TableCell align="center">{yearField}</TableCell>
                        {projectPlans &&
                          this.monthCells()
                        }
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow className="pl-heading">
                        <TableCell align="center">
                          <div className="innerMonth">
                            <div className="bluebox">Verk</div>
                            <div className="light-bluebox">Verg</div>
                            <div>Ist</div>
                          </div>
                        </TableCell>
                        {monthList &&
                          monthList.map((item, index) =>
                            <TableCell key={index} align="center">
                              <div className="innerMonth">
                                <div className="bluebox">Verk</div>
                                <div className="light-bluebox">Verg</div>
                                <div>Ist</div>
                              </div>
                            </TableCell>
                          )
                        }
                      </TableRow>
                      {projectPlans &&
                        projectPlans.map((item, index) =>
                          <TableRow key={index}>
                            {monthsKey.map((month, index) =>
                              item.project_plans[month] ?
                                <TableCell key={index} align="center">
                                  <div className="innerMonth">
                                    <div className="bluebox">
                                      <NumberFormat
                                        customInput={TextField}
                                        className="innerInput rightToLeft"
                                        inputProps={{
                                          maxLength: 10
                                        }}
                                        disabled={month === "summary" || (((yearField === new Date().getFullYear() && cuurentMonth >= index) || yearField < new Date().getFullYear()) && Number(access_rights.project_planning_all_over) === 0) ? true : false}
                                        variant="outlined"
                                        value={item.project_plans[month][0].dayssold !== null ? Number(item.project_plans[month][0].dayssold) : ''}
                                        thousandSeparator='.'
                                        decimalSeparator=","
                                        fixedDecimalScale={true}
                                        decimalScale="1"
                                        allowNegative={false}
                                        onChange={(e) => this.handleFieldsChange(e, item, month, "dayssold")}
                                      />
                                    </div>
                                    <div className="light-bluebox">
                                      <NumberFormat
                                        customInput={TextField}
                                        className="innerInput rightToLeft"
                                        inputProps={{
                                          maxLength: 10
                                        }}
                                        disabled={month === "summary" || (((yearField === new Date().getFullYear() && cuurentMonth >= index) || yearField < new Date().getFullYear()) && Number(access_rights.project_planning_all_over) === 0) ? true : false}
                                        variant="outlined"
                                        value={item.project_plans[month][0].daysassigned !== null ?
                                          Number(item.project_plans[month][0].daysassigned) : ''}
                                        thousandSeparator='.'
                                        decimalSeparator=","
                                        fixedDecimalScale={true}
                                        decimalScale="1"
                                        allowNegative={false}
                                        onChange={(e) => this.handleFieldsChange(e, item, month, "daysassigned")}

                                      />
                                    </div>
                                    <div>
                                      <NumberFormat
                                        customInput={TextField}
                                        className="innerInput rightToLeft"
                                        disabled
                                        variant="outlined"
                                        value={item.project_plans[month][0].ist !== "0.0" ? Number(item.project_plans[month][0].ist) : ''}
                                        thousandSeparator='.'
                                        decimalSeparator=","
                                        fixedDecimalScale={true}
                                        decimalScale="1"
                                        allowNegative={false}
                                      />
                                    </div>
                                  </div>
                                </TableCell>
                                :
                                <TableCell key={index} align="center">
                                  <div className="innerMonth">
                                    <div className="bluebox">
                                      <NumberFormat
                                        customInput={TextField}
                                        className="innerInput rightToLeft"
                                        inputProps={{
                                          maxLength: 10
                                        }}
                                        value={''}
                                        variant="outlined"
                                        thousandSeparator='.'
                                        decimalSeparator=","
                                        fixedDecimalScale={true}
                                        disabled={month === "summary" || (((yearField === new Date().getFullYear() && cuurentMonth >= index) || yearField < new Date().getFullYear()) && Number(access_rights.project_planning_all_over) === 0) ? true : false}
                                        decimalScale="1"
                                        allowNegative={false}
                                        onChange={(e) => this.handleNewMonthAdd(e, item, month, "dayssold")}
                                      /></div>
                                    <div className="light-bluebox">
                                      <NumberFormat
                                        customInput={TextField}
                                        className="innerInput rightToLeft"
                                        inputProps={{
                                          maxLength: 10
                                        }}
                                        value={''}
                                        variant="outlined"
                                        thousandSeparator='.'
                                        decimalSeparator=","
                                        fixedDecimalScale={true}
                                        disabled={month === "summary" || (((yearField === new Date().getFullYear() && cuurentMonth >= index) || yearField < new Date().getFullYear()) && Number(access_rights.project_planning_all_over) === 0) ? true : false}
                                        decimalScale="1"
                                        allowNegative={false}
                                        onChange={(e) => this.handleNewMonthAdd(e, item, month, "daysassigned")}
                                      />
                                    </div>
                                    <div>
                                      <NumberFormat
                                        customInput={TextField}
                                        className="innerInput rightToLeft"
                                        value={''}
                                        disabled
                                        variant="outlined"
                                        fixedDecimalScale={true}
                                        thousandSeparator='.'
                                        decimalSeparator=","
                                        decimalScale="1"
                                        allowNegative={false}
                                      />
                                    </div>
                                  </div>
                                </TableCell>

                            )}

                          </TableRow>
                        )
                      }
                      <TableRow>
                        {monthsKey &&
                          monthsKey.map((item, index) =>
                            <TableCell key={index} align="center">
                              <div className="innerMonth">
                                <div className="bluebox">
                                  <NumberFormat
                                    customInput={TextField}
                                    className="innerInput rightToLeft"
                                    disabled
                                    value={sumDaysold[index] !== 0.0 ? sumDaysold[index] : ''}

                                    fixedDecimalScale={true}
                                    thousandSeparator='.'
                                    decimalSeparator=","
                                    decimalScale="1"
                                    allowNegative={false}
                                  />
                                </div>
                                <div className="light-bluebox">
                                  <NumberFormat
                                    customInput={TextField}
                                    className="innerInput rightToLeft"
                                    disabled

                                    value={sumDaysassigned[index] !== 0.0 ? sumDaysassigned[index] : ''}
                                    fixedDecimalScale={true}
                                    thousandSeparator='.'
                                    decimalSeparator=","
                                    decimalScale="1"
                                    allowNegative={false}
                                  />
                                </div>
                                <div>
                                  <NumberFormat
                                    customInput={TextField}
                                    className="innerInput rightToLeft"
                                    disabled

                                    fixedDecimalScale={true}
                                    value={sumIst[index] !== 0.0 ? sumIst[index] : ''}
                                    thousandSeparator='.'
                                    decimalSeparator=","
                                    decimalScale="1"
                                    allowNegative={false}
                                  />
                                </div>
                              </div>
                            </TableCell>
                          )
                        }
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Grid>
          </Grid>
          {!isEmpty(comparedValText) && <span style={{ color: color, float: "right", marginTop: "10px" }}>{comparedValText}</span>}
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ projectsData }) => {
  return {
    project_plans_for_year: projectsData.project_plans_for_year,
    rest_gemsat: projectsData.rest_gemsat,
    rest_year: projectsData.rest_year,

  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetProjectPlansForYear: (id, date) => dispatch(GetProjectPlansForYear(id, date)),
    CreateProjectPlansForYear: (id, data, months, year) => dispatch(CreateProjectPlansForYear(id, data, months, year)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Planning)